module.exports = "/_next/static/images/logo-new-e110a2f2fce0f4077a9b1c1385e2ee5c.svg";